<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>Process operator</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title>
          <v-container grid-list-md fluid class="pa-0">
            <v-layout align-center justify-end row fill-height>
              <v-flex class="text-xs-right" xs10>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  class="ma-0 pa-0"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex class="text-xs-right" xs2>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      small
                      color="success"
                      v-on="on"
                      @click="openSettings"
                    >
                      <v-icon>settings</v-icon>
                    </v-btn>
                  </template>
                  <span>Settings</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-title>
        <v-divider></v-divider>
        <data-table
          :items="allItems"
          :headers="headers"
          :search="search"
        />
        <data-table-settings-popup
          :headers.sync="headers"
          :dialog.sync="settingsPopupStatus"
        />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import asyncComponent from '@/utils/asyncComponent';
import Trial from '@/orm/models/Trial';
import ProcessStages from '@/orm/models/ProcessStages';
import { CONST } from '@/utils';

export default {
  name: 'PO',
  data() {
    return {
      search: '',
      settingsPopupStatus: false,
      queryParams: {
        scheduled_date__from: new Date().toISOString().substr(0, 10),
      },
      headers: [...CONST.trial.headers],
    };
  },
  async mounted() {
    const query = this.createQueryParams(this.queryParams);
    await this.fetch(query);
  },
  computed: {
    allItems() {
      return Trial
        .query()
        .where('status', status => {
          return ![
            'DRAFT',
            'CLOSED',
            'CANCELED',
            'COMPLETED',
            'ON_APPROVAL'
          ].includes(status);
        })
        .with('processes')
        .get();
    },
  },
  methods: {
    async fetch(query) {
      await Trial.deleteAll();
      await ProcessStages.$fetch();
      await Trial.$fetch({
        params: {
          query,
        },
      });
    },
    createQueryParams(queryParams) {
      const query = new URLSearchParams();
      Object
        .entries(queryParams)
        .forEach(([k, value]) => query.append(k, value));
      return query;
    },
    openSettings() {
      this.settingsPopupStatus = true;
    },
  },
  components: {
    dataTable: asyncComponent({
      component: 'components/dashboards/PO/dataTable',
    }),
    dataTableSettingsPopup: () => import('@/components/data/dataTableSettingsPopup'),
  },
};
</script>
